interface ICOLOR {
  primary: string;
  primaryLight: string;
  error: string;
  errorLight: string;
  warning: string;
  warningLight: string;
  success: string;
  successLight: string;
}

const getColorPalette = (): ICOLOR => {
  const color: ICOLOR = {
    primary: "#F1C40F",
    primaryLight: "#E4E6FF",
    error: "#ff6262",
    errorLight: "#fff0f0",
    warning: "#d88e1f",
    warningLight: "#fbf8f0",
    success: "#329d7c",
    successLight: "#e5f5f0",
  };

  return color;
};

export const mapTheme = (color: ICOLOR) => {
  return {
    "--primary": color.primary,
    "--primary-light": color.primaryLight,

    "--error": color.error,
    "--error-light": color.errorLight,

    "--warning": color.warning,
    "--warning-light": color.warningLight,

    "--success": color.success,
    "--success-light": color.successLight,
  };
};

export const COLOR_PALETTE = getColorPalette();

export const applyColorPaletteToDOM = () => {
  const themeObject = mapTheme(COLOR_PALETTE);
  if (!themeObject) return;
  const root = document.documentElement;

  Object.keys(themeObject).forEach((property) => {
    root.style.setProperty(
      property,
      themeObject[property as keyof typeof themeObject]
    );
  });
};
